import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Select } from '@ngxs/store';
import { AuctionItem, ImageMetaData } from 'remarketing-angular-library';
import { VehicleOptionsMetaData, VehicleIconComponent } from 'remarketing-ui-components-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fromMatchMedia, SaComponent } from 'smartauction-frontend-micro-library';
import { DetailsHeaderQuery } from 'src/sell/lib/details/interfaces/detail-header.query';
import { DetailsQueries } from 'src/sell/lib/details/queries/details.queries';
import { AutoVisionSellerLocationComponent } from '../auto-vision-seller-location/auto-vision-seller-location.component';
import { AutoVisionConditionDisclosuresComponent } from '../auto-vision-condition-disclosures/auto-vision-condition-disclosures.component';
import { AutoVisionEquipmentAccessoriesComponent } from '../auto-vision-equipment-accessories/auto-vision-equipment-accessories.component';
import { AutoVisionVehicleDetailsComponent } from '../auto-vision-vehicle-details/auto-vision-vehicle-details.component';
import { AutoVisionAuctionDetailComponent } from '../auto-vision-auction-detail/auto-vision-auction-detail.component';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-auto-vision-print-vdp',
    templateUrl: './auto-vision-print-vdp.component.html',
    styleUrls: ['./auto-vision-print-vdp.component.scss'],
    imports: [NgTemplateOutlet, AutoVisionAuctionDetailComponent, AutoVisionVehicleDetailsComponent, AutoVisionEquipmentAccessoriesComponent, AutoVisionConditionDisclosuresComponent, AutoVisionSellerLocationComponent, VehicleIconComponent]
})
export class AutoVisionPrintVdpComponent extends SaComponent implements OnInit {
  isDesktop$ = fromMatchMedia('(min-width: 992px)');
  @Select(DetailsQueries.images) images$: Observable<ImageMetaData[]>;
  @Select(DetailsQueries.equipmentAccessories) options$: Observable<VehicleOptionsMetaData>;
  @Input() images: ImageMetaData[];
  @Input() header: DetailsHeaderQuery;
  @Input() auctionItem: AuctionItem;
  @Input() showHeading = true;

  maxEquipRows = 100;
  autovisionPrintVdpTranslations = {
    mainImage: '',
    photos: '',
    detailCarouselData: ''
  };

  constructor(private readonly translocoService: TranslocoService) {
    super();
  }

  ngOnInit(): void {}

  getTranslations() {
    const keyParams = {
      'sellModule.details.printVdp': {},
      'UIComponents': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translate => {
        this.autovisionPrintVdpTranslations.mainImage = translate[0].mainImage;
        this.autovisionPrintVdpTranslations.photos = translate[0].photos;
        this.autovisionPrintVdpTranslations.detailCarouselData = translate[1].detailCarousel;
      });
  }
}
